










import {defineComponent, PropType} from "@vue/composition-api";
import {ErrorObject} from "@vuelidate/core";

export default defineComponent({
    props: {
        errors: {
            type: Array as PropType<ErrorObject[]>,
        }
    }
})
